import React from "react";
import { Link, useHistory } from "react-router-dom";
import AdminRemoteDomainsTable from "./sourcesAndPulls/AdminRemoteDomainsTable";
import AdminRemoteRecentPullsTable from "./sourcesAndPulls/AdminRemoteRecentPullsTable";

export default function AdminRemote() {
  const history = useHistory();

  return (
    <>
      <h1>
        <Link to={"/admin"}>Admin</Link> - Remote Data
      </h1>
      <button
        className={"btn"}
        onClick={(e) => {
          e.preventDefault();
          history.push("/admin/remote/config/add");
        }}
      >
        Add Config
      </button>
      <h2>Domains</h2>
      <AdminRemoteDomainsTable />
      <AdminRemoteRecentPullsTable />
    </>
  );
}
